import React, { useState } from 'react';
import './LinkRoleTypeForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import FieldHelp from '../../../shared/FieldHelp';

// Shared with LinkRoleTypeTable's Priority column "?" (same fieldKey), so
// both read the same default text.
export const PRIORITY_HELP = 'Controls which linked person is shown as the main contact on a Pipeline card — whoever holds the current, active link with the lowest number here wins. Also sets the order people are listed in on an entity\'s own page. It doesn\'t restrict who can hold the role or trigger anything else. Set it wrong and the "wrong" person just shows as top contact — nothing breaks, and you can fix it any time; other roles renumber automatically to stay consistent.';

const CATEGORY_OPTIONS = [
  { value: 'individual', label: 'Individuals' },
  { value: 'organization', label: 'Organisations' },
];

function LinkRoleTypeForm({ initial, onSave, onCancel, loading }) {
  const [name, setName] = useState(initial?.name || '');
  const [inverseName, setInverseName] = useState(initial?.inverse_name || '');
  const [category, setCategory] = useState(initial?.category || 'individual');
  const [priority, setPriority] = useState(initial?.priority != null ? String(initial.priority) : '');
  const [error, setError] = useState('');

  const validate = () => {
    if (!name.trim()) return 'Name is required.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    const payload = { name: name.trim(), category, inverse_name: inverseName.trim() };
    if (category === 'individual' && priority.trim()) payload.priority = Number(priority);
    onSave(payload);
  };

  return (
    <form className="link-role-type-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div>
        <label>Name<RequiredMark /></label><br />
        <input
          className="styled-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Employee"
          style={{ width: 260 }}
        />
      </div>

      <div style={{ marginTop: 12 }}>
        <label>Reverse label</label><br />
        <input
          className="styled-input"
          value={inverseName}
          onChange={(e) => setInverseName(e.target.value)}
          maxLength={100}
          placeholder="e.g., Employs (optional — defaults to Name)"
          style={{ width: 260 }}
        />
      </div>

      <div style={{ marginTop: 12 }}>
        <label>Applies to<RequiredMark /></label><br />
        <select
          className="styled-input"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ width: 260 }}
        >
          {CATEGORY_OPTIONS.map((opt) => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
        </select>
      </div>

      {category === 'individual' && (
        <div style={{ marginTop: 12 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
            <label>Priority</label>
            <FieldHelp
              fieldKey="global-link-role-types.priority"
              pageKey="global-link-role-types"
              articleSlug="entities"
              articleTitle="Commercial Entities"
              label="Priority"
            >
              {PRIORITY_HELP}
            </FieldHelp>
          </span>
          <br />
          <input
            className="styled-input"
            type="number"
            min={1}
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            placeholder="Last (least important)"
            style={{ width: 260 }}
          />
          <div style={{ fontSize: 12, color: '#5a6b85', marginTop: 4 }}>
            1 = most important. Other roles renumber automatically to make room.
          </div>
        </div>
      )}

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default LinkRoleTypeForm;
